'use es6';

export const EXPIRES_AT = ['expiresAt'];
export const URL = ['url'];
export const NAME = ['name'];
export const EXTENSION = ['extension'];
export const TYPE = ['type'];
export const SIZE = ['fileSize'];
export const WIDTH = ['width'];
export const HEIGHT = ['height'];